import React from 'react';
// import ProductItem from '../components/ProductItem';
import ProductItem from '../../components/ProductItem';
import Footer from '../../components/Footer/Footer';
import './home.styles.css'

const Home = () => {
  return (
    <div>
   <ProductItem/>
  <Footer/> 
    </div>
  )
};

export default Home;